import React, { useState, useEffect } from 'react';
import OAuthLogin from './components/OAuthLogin';
import Dashboard from './components/Dashboard';
import { performAutoLogin } from './utils/autoLogin';

const App: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<string | null>(null);

  useEffect(() => {
    // Check if we're on the OAuth login route
    const path = window.location.pathname;
    if (path === '/oauth/login') {
      // OAuth login page will be handled by OAuthLogin component
      return;
    }

    // Check for existing session (use localStorage for persistence across browser sessions)
    const savedUser = localStorage.getItem('current_user');
    if (savedUser) {
      setCurrentUser(savedUser);
    }
  }, []);

  const handleLogin = (userEmail: string) => {
    setCurrentUser(userEmail);
    localStorage.setItem('current_user', userEmail);
    
    // If we came from OAuth flow, redirect back to main dashboard
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('client_id')) {
      window.history.replaceState({}, document.title, '/');
    }
  };

  const handleLogout = () => {
    setCurrentUser(null);
    localStorage.removeItem('current_user');
    sessionStorage.removeItem('oauth_state');
  };

  const handleAppAccess = (appId: string, variantId?: string) => {
    if (currentUser) {
      performAutoLogin(appId, currentUser, variantId);
    }
  };

  // Check if we're on OAuth login route
  const isOAuthLogin = window.location.pathname === '/oauth/login' || 
                      new URLSearchParams(window.location.search).get('client_id');

  return (
    <div>
      {currentUser && !isOAuthLogin ? (
        <Dashboard
          userEmail={currentUser}
          onLogout={handleLogout}
          onAppAccess={handleAppAccess}
        />
      ) : (
        <OAuthLogin onSuccess={handleLogin} />
      )}
    </div>
  );
};

export default App;